import type { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { amount } from './api';
import { revisionAttention, revisionDelta, revisionKindLabels, type RevisionDifference } from './revisionAttention';
import './revision-actions.css';

export function RevisionActionView({ items, renderDetail }: { items: RevisionDifference[]; renderDetail: (item: RevisionDifference) => ReactNode }) {
  return <div className="revision-actions">
    <p className="ra-intro">Что проверить — в строке. Полные описания, источники и пояснение результата сравнения — внутри. Каждое соответствие показано отдельно.</p>
    {items.map((item, index) => {
      const attention = revisionAttention(item), delta = revisionDelta(item);
      return <details className={`ra-card ra-${attention.tone}`} key={`${item.before?.id || ''}:${item.after?.id || ''}:${index}`}>
        <summary><ChevronRight size={18} className="ra-chevron" aria-hidden="true" />
          <span className="ra-subject"><small>{revisionKindLabels[item.kind]}</small><strong>{item.after?.description || item.before?.description || 'Позиция ведомости'}</strong>
            <span className={`ra-action ra-action--${attention.tone}`}>{item.kind === 'unchanged' ? attention.action : `Что сделать: ${attention.action}`}</span>
            <span className="ra-note">{attention.note}</span></span>
          <span className="ra-values">{([item.before, item.after] as const).map((side, i) => <span key={i}><small>{i === 0 ? 'Было' : 'Стало'}</small>
            <b>{!side ? 'Нет позиции' : side.quantity == null || side.quantity.trim() === '' ? 'Объём не установлен' : `${amount(side.quantity)} ${side.unit}`.trim()}</b>
            {side && <small>{side.group || side.category}</small>}</span>)}
            <span><small>Разность</small><b>{delta.value == null ? '—' : `${amount(delta.value)} ${delta.unit}`}</b><small>{delta.note}</small></span></span>
          <span className="ra-more">Подробнее</span>
        </summary>
        <div className="ra-body">{renderDetail(item)}</div>
      </details>;
    })}
    {!items.length && <p className="empty">По выбранным условиям изменений нет. Это не подтверждает полноту обеих ведомостей.</p>}
  </div>;
}
